import ChangePasswordFormModal from "./user/components/ChangePasswordFormModal";
import {useDispatch} from "react-redux";
import {setManageUserModals} from "../redux/slices/manageUserSlice";
import {useNavigate} from "react-router-dom";
import CustomIcon from "components/CustomIcon";

export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const navigateToProfile = () => {
    navigate("/profile")
  };
  return (
    <div className="px-3 md:px-8 h-auto -mt-24">
      <h2 className="text-2xl text-white mb-8 ml-5">Hello, Admin</h2>
      <div className="grid grid-cols-2 gap-6 items-center">
        <DashboardItem label="Profile" onClick={navigateToProfile} icon="person_outline"/>
        <DashboardItem label="Change Password" onClick={() => dispatch(setManageUserModals({modal: true, data: {password: true}, isPassword: true}))} icon="lock_reset"/>
      </div>      
      <ChangePasswordFormModal/>
    </div>
  );
}

export const DashboardItem = ({label, icon, onClick}) => {
  return (
    <div onClick={onClick} className="w-full bg-white rounded-xl overflow-hdden shadow-md px-4 py-6 cursor-pointer text-base font-medium flex items-center justify-between hover:scale-105 transition-all"> <div className="flex space-x-3 items-center"><div className="p-2 rounded-xl bg-secondary-100 w-12 h-12 text-secondary-500"><CustomIcon icon={icon} size="3xl"/></div> <span>{label}</span></div><CustomIcon icon="keyboard_arrow_right" size="2xl"/>
    </div>
  );
};
